// removed by extract-text-webpack-plugin
module.exports = {"block":"Link__block-2iVJj"};